var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { CheckCircleFilled } from '@ant-design/icons';
var OFFSET = 5;
var BORDER_THICKNESS = 1;
var PX = 'px';
export var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"], ["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var size = _a.size;
    return size - OFFSET + PX;
}, function (_a) {
    var size = _a.size;
    return size - OFFSET + PX;
}, function (_a) {
    var size = _a.size;
    return (size - OFFSET) / 2 + PX;
});
export var StyledCameo = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  position: relative;\n"], ["\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  position: relative;\n"])), function (_a) {
    var size = _a.size;
    return size + PX;
}, function (_a) {
    var size = _a.size;
    return size + PX;
}, function (_a) {
    var border_color = _a.border_color;
    return "".concat(BORDER_THICKNESS + PX, " solid ").concat(border_color);
}, function (_a) {
    var size = _a.size;
    return size / 2 + PX;
});
export var StyledImageWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"])));
export var StyledIcon = styled(CheckCircleFilled)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  border-radius: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  border-radius: ", ";\n"])), function (_a) {
    var size = _a.size;
    return size / 3 + PX;
}, function (_a) {
    var border_color = _a.border_color;
    return border_color;
}, function (_a) {
    var size = _a.size;
    return size / 6 + PX;
});
export var StyledInitials = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  text-align: center;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  text-align: center;\n"])), function (_a) {
    var size = _a.size;
    return size / 3 + PX;
}, function (_a) {
    var size = _a.size;
    return size + PX;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
